import React from 'react';

const FormatDateString = (date) => {
    const formattedDate = date?.split('T')[0]; // Split the date string to remove time information
    return new Date(formattedDate).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
    });
};

export default FormatDateString;
